<!-- @format -->
<section
	[ngClass]="marginTop"
	[id]="filterMore(heading.header | dcsgStripSpecialChars: '\ |\'|\′|\&|\-')"
	class="position-relative d-flex flex-column"
	*ngFor="let heading of data; let i = index">
	<div [ngClass]="returnColor(heading.contentBackgroundColor, heading.textColor)">
		<div
			class="d-flex hmf-mb-s hmf-mb-m-m {{
				chainAbbr === 'pl' ? 'flex-column flex-md-row' : 'flex-row'
			}}"
			[ngClass]="{ 'text-md-center': !heading.cta }">
			<ng-template
				[ngTemplateOutlet]="spacer"
				*ngIf="chainAbbr !== 'pl' && heading.cta"></ng-template>
			<div
				*ngIf="!heading.description"
				[ngClass]="{
					'col-8 col-md-8': heading.cta,
					'col-12': !heading.cta || chainAbbr === 'pl'
				}">
				<ng-template
					[ngTemplateOutlet]="badge"
					*ngIf="heading.badge && (heading.badge[0] | keyvalue)?.length"></ng-template>
				<ng-template [ngTemplateOutlet]="header"></ng-template>
			</div>
			<div
				*ngIf="heading.description"
				[ngClass]="{
					'col-8 col-md-8': heading.cta,
					'col-12': !heading.cta || chainAbbr === 'pl'
				}">
				<ng-template
					[ngTemplateOutlet]="badge"
					*ngIf="heading.badge && (heading.badge[0] | keyvalue)?.length"></ng-template>
				<ng-template [ngTemplateOutlet]="header"></ng-template>
				<ng-template [ngTemplateOutlet]="description"></ng-template>
			</div>
			<ng-container *ngIf="heading.cta">
				<home-cta
					*ngFor="let cta of heading.cta; let j = index"
					[ngClass]="{ 'col-md-2': chainAbbr !== 'pl' }"
					class="{{
						chainAbbr === 'pl'
							? 'col-12 col-md-4 justify-content-start justify-content-md-end'
							: 'col-4 justify-content-end'
					}}"
					[data]="cta"
					[addlData]="addlData"
					[ctaIndex]="j + 1"
					[altText]="heading.header"
					[parentIndex]="1">
				</home-cta>
			</ng-container>
		</div>
	</div>
	<ng-template #header>
		<h2
			[ngStyle]="{ color: isGGStaticPage ? ggStaticColors.primary : '' }"
			[ngClass]="chainAbbr === 'pl' && heading.cta ? 'text-md-left' : 'text-md-center'"
			class="text--subhead text-left {{
				chainAbbr === 'pl' && !heading.description ? 'hmf-mb-s hmf-mb-m-0' : ''
			}}">
			{{ heading.header }}
		</h2>
	</ng-template>
	<ng-template #spacer>
		<div
			class="d-none d-md-block col-2"
			*ngIf="heading.cta"></div>
	</ng-template>
	<ng-template #description>
		<p
			[ngStyle]="{ color: isGGStaticPage ? ggStaticColors.secondary : '' }"
			[ngClass]="
				chainAbbr === 'pl' && heading.cta
					? 'text-md-left hmf-mb-s hmf-mb-m-0'
					: 'text-md-center'
			"
			class="text text--subtext text-left {{ chainAbbr !== 'pl' ? 'hmf-mb-0' : '' }}">
			{{ heading.description }}
		</p>
	</ng-template>
	<ng-template #badge>
		<engage-badge
			[data]="heading.badge"
			[ngClass]="chainAbbr === 'pl' && heading.cta ? 'text-md-left' : 'text-md-center'"
			class="text-nowrap {{ chainAbbr === 'pl' ? 'transparent' : '' }}">
		</engage-badge>
	</ng-template>
</section>
